import { createStore } from "owa-satcheljs";
import type { CopilotAccountPickerStore } from "./schema/CopilotAccountPickerStoreSchema";

const initialStore: CopilotAccountPickerStore = {
    accountOptions: [],
    currentAccount: null,
};

export const getStore: () => CopilotAccountPickerStore = createStore<CopilotAccountPickerStore>("CopilotAccountPickerStore", initialStore);
